import { useEffect, useState } from 'react';
import type { ZuoraCreditCardDetailsOptions } from '../types';

declare global {
  interface Window {
    Z: ZuoraLibrary;
  }
}

// FIXME: camelcase
/* eslint-disable camelcase */
export interface CallbackSuccess {
  success: true;
  AuthorizeResult: string;
  ThreeDSResult: string;
  field_passthrough1: string;
  field_passthrough2: string;
  field_passthrough3: string;
  field_passthrough4: string;
  field_passthrough5: string;
  nextStep: string;
  rawGatewayInfo: {
    type: string;
    responseMessage: string;
    version: string;
    responseCode: string;
  };
  redirectUrl: string;
  refId: string;
  responseFrom: string;
  signature: string;
  token: string;
  zThreeDs2TxId: string;
}
// FIXME: camelcase
/* eslint-enable camelcase */

export interface CallbackFailure {
  success: false;
  errorCode: string;
  errorMessage: string;
  responseFrom: string;
}

export type CallbackResponse = CallbackSuccess | CallbackFailure;

export interface ZuoraLibrary {
  renderWithErrorHandler(
    parameters: ZuoraCreditCardDetailsOptions,
    prepopulateFields: Record<string, unknown>,
    callback: (response: CallbackResponse) => void,
    handleErrors: (key: string, code: string, message: string) => void,
  ): void;
  sendErrorMessageToHpm(key: string, errorMessage: string): void;
  setEventHandler(event: 'onloadCallback', callback: () => void): void;
}

// we only ever want this library to load when we need to use it here, so doing some old school script loading
const loadZuoraLibrary: () => Promise<ZuoraLibrary> = () =>
  new Promise((resolve, reject) => {
    if (window.Z) {
      resolve(window.Z);
      return;
    }

    const script = document.createElement('script');
    document.head.append(script);

    script.src = 'https://static.zuora.com/Resources/libs/hosted/1.3.1/zuora-min.js';

    // technically Z is a global var now, but sending it through with an interface to
    // avoid just using it off the window and to know what methods are available
    // NOTE: the interface only has the methods we actually use
    script.onload = () => resolve(window.Z);
    script.onerror = reject;
  });

export const useZuoraLibrary = (): ZuoraLibrary | undefined => {
  const [zuora, setZuora] = useState<ZuoraLibrary>();

  useEffect(() => {
    loadZuoraLibrary()
      .then(setZuora)
      .catch(() => null);
  }, []);

  return zuora;
};
